module.exports = __webpack_public_path__ + "81f59f2b22a51529e878e5ca428f9956.png";